import { createPublicSearchTool } from '@proj-airi/stage-ui/libs/velis-companion-tools'
import { useLlmToolsStore } from '@proj-airi/stage-ui/stores/ai/chat-llm/tools'

const searchToolId = 'velis:search-public'

/** Registers Wikipedia search for web chat. Desktop-only tools stay unregistered. */
export function registerWebPublicSearch() {
  useLlmToolsStore().addTools({
    ...createPublicSearchTool(),
    id: searchToolId,
    requiresExplicitSelection: true,
  })
}

/** Removes the web Wikipedia search tool. */
export function disposeWebPublicSearch() {
  useLlmToolsStore().removeToolsByIds(searchToolId)
}
